import { useState, useEffect } from "react";
import { useToastPromise } from "../../components/toastPromise";
import { CollaborationController } from "../../controllers/collaborationController";
import "../../assets/css/collaboration.css";
import { Collaboration } from "./collaboration";
import { TableList } from "../../components/tableList";
import { MediaPreview } from "./mediaPreview";

export const AllCollaboration = ({ user }) => {
  const toastPromise = useToastPromise();
  const [loading, setLoading] = useState(false);
  const [collaborationList, setCollaborationList] = useState([]);
  const [isOpen, setIsOpen] = useState(false);
  const [isPreviewOpen, setIsPreviewOpen] = useState(false);
  const [selectedData, setSelectedData] = useState(null);
  useEffect(() => {
    getAll();
  }, []);
  const getAll = () => {
    setLoading(true);
    toastPromise({
      promise: new Promise((resolve, reject) => {
        CollaborationController.getAll({
          resolve: resolve,
          reject: reject,
        });
      }),
      successMessage: (data) => {
        const fetchedData = data.docs.map((doc) => ({
          ...doc.data(),
          id: doc.id,
        }));
        setCollaborationList(fetchedData);
        return "Collaboration details retrieved successfully.";
      },
      errorMessage: (data) => data,
    }).finally(() => setLoading(false));
  };
  const handleDeleteSelected = (selectedRows, success) => {
    setLoading(true);
    toastPromise({
      promise: new Promise((resolve, reject) => {
        CollaborationController.deleteAll({
          idList: selectedRows,
          resolve: resolve,
          reject: reject,
        });
      }),
      successMessage: success,
      errorMessage: (data) => data,
    }).finally(() => setLoading(false));
  };
  const handlePopupDialogOpen = (collaboration = null) => {
    setSelectedData(collaboration);
    setIsOpen(true);
  };
  const handleClose = () => {
    setIsOpen(false);
  };
  const handlePreviewPopupDialogOpen = (medias = null, type = null) => {
    setSelectedData({ medias: medias, type: type });
    setIsPreviewOpen(true);
  };
  const handlePreviewClose = () => {
    setIsPreviewOpen(false);
  };

  return (
    <section id="collaborationList">
      <h4>COLLABORATION LISTS</h4>
      <hr />
      <TableList
        loading={loading}
        list={collaborationList}
        handlePopupDialogOpen={handlePopupDialogOpen}
        handlePreviewPopupDialogOpen={handlePreviewPopupDialogOpen}
        deletePromise={(selectedRows, success) => {
          handleDeleteSelected(selectedRows, success);
        }}
      />
      <Collaboration
        user={user}
        isOpen={isOpen}
        handleClose={handleClose}
        getAll={getAll}
        selectedData={selectedData}
      />
      <MediaPreview
        isPreviewOpen={isPreviewOpen}
        handlePreviewClose={handlePreviewClose}
        content={selectedData?.medias ?? []}
        type={selectedData?.type ?? ""}
      />
    </section>
  );
};
